import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateAdminDeductionRequest } from '@billda/api';
import { createAdminDeduction } from '../api/deductionsAdminApi';
import { deductionsKeys } from './useGetDeductions';
import { potKeys } from './potKeys';

/**
 * Mutation hook for creating an admin deduction.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useCreateAdminDeduction() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateAdminDeductionRequest) =>
      createAdminDeduction(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: deductionsKeys.all });
      queryClient.invalidateQueries({ queryKey: potKeys.all });
    },
  });
}
